var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMatchingRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 18",
    style: {
      enableBackground: "new 0 0 20 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,13.6C4.7,13.6,4.7,13.6,4.7,13.6H4.2c-0.9,0-1.8-0.3-2.5-0.9c-0.7-0.6-1.2-1.4-1.4-2.3 C0.1,9.6,0.2,8.6,0.6,7.8c0.4-0.8,1-1.4,1.8-1.8c0.1-1.3,0.7-2.4,1.6-3.3c1-0.9,2.2-1.4,3.5-1.4c0,0,0,0,0,0c1.1,0,2.2,0.4,3.1,1 c0.5-0.2,1-0.3,1.5-0.3c1.1,0,2.1,0.4,2.9,1.1c0.8,0.7,1.3,1.6,1.5,2.6C17.6,6,18.4,6.5,19,7.2C19.6,8,19.9,9,19.8,10 c-0.1,1-0.5,1.9-1.3,2.6c-0.7,0.6-1.5,1-2.5,1v0l-0.8,0c-0.2,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.4s0.1-0.3,0.2-0.4 c0.1-0.1,0.3-0.2,0.4-0.2h0.6c0.7,0,1.4-0.3,1.9-0.8c0.5-0.5,0.8-1.2,0.9-1.9c0-0.7-0.2-1.4-0.7-1.9S16.8,7,16.1,6.9 c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.2-0.2-0.4c-0.1-0.8-0.4-1.6-1-2.1c-0.6-0.6-1.4-0.9-2.2-0.9c-0.5,0-0.9,0.1-1.4,0.3 c-0.1,0-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.3-0.1C9.5,2.9,8.6,2.6,7.6,2.6c0,0,0,0,0,0c-1,0-2,0.4-2.8,1.1C4.1,4.5,3.7,5.4,3.6,6.5 c0,0.1,0,0.2-0.1,0.3C3.4,6.9,3.3,7,3.2,7.1C2.6,7.3,2.1,7.7,1.8,8.3s-0.4,1.2-0.3,1.9c0.1,0.6,0.4,1.2,0.9,1.6 c0.5,0.4,1.1,0.6,1.8,0.6h0.5c0.1,0,0.2,0,0.2,0c0.1,0,0.2,0.1,0.2,0.1c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.2 c0,0.1,0,0.2-0.1,0.2c0,0.1-0.1,0.1-0.1,0.2c-0.1,0.1-0.1,0.1-0.2,0.1C4.8,13.6,4.8,13.6,4.7,13.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15,16.3c0,0.1,0,0.2-0.1,0.2c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.2,0-0.3-0.1l-1.8-1.8 c-0.7,0.6-1.7,0.9-2.7,0.8c-1-0.1-1.9-0.5-2.5-1.2c-0.7-0.7-1-1.7-1-2.6c0-1,0.4-1.9,1.1-2.6C8.2,8.4,9.1,8,10.1,8s1.9,0.3,2.6,1 c0.7,0.6,1.2,1.5,1.2,2.5c0.1,1-0.2,1.9-0.8,2.7l1.8,1.8C14.9,16.1,15,16.2,15,16.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchingRules);
export default __webpack_public_path__ + "static/media/matchingRules.df0c4f26.svg";
export { ForwardRef as ReactComponent };